const postBindLocationList = {
  country: '',
  state: '',
  city: '',
  port: '',
  postal: '',
  byName: '',
  sectionInUse: '',
  type: '',
  //totalPageSize: 0,
  pageNo: 1,
  pageSize: 10,
};

export default postBindLocationList;
